import { useAuth } from "../../../context/AuthContext";
import { dictionary } from "../../../utils/dictionary";

interface ButtonResetTypeProductProps {
  onClick: () => void;
}

export default function ButtonResetTypeProduct({ onClick }: ButtonResetTypeProductProps) {
  const { language } = useAuth();
  
  return (
    <button className="text-base text-[#7C3AED] opacity-100 hover:opacity-50" onClick={onClick}>
      {dictionary["choose-different-method"][language]}
    </button>
  );
}